import { Dispatch } from "@reduxjs/toolkit";
import { api } from "../config/api";
import { GetState } from "../config/store";
import { 
    setBranchDashboard as setBranchDashboardReducer,
    setDateDashboard as setDateDashboardReducer,
    getSalesPeriodRequest,
    getSalesPeriodSuccess,
    getSalesPeriodFailure,
    cleanSalesPeriod as cleanSalesPeriodReducer,
    getSalesAcumulatedRequest,
    getSalesAcumulatedSuccess,
    getSalesAcumulatedFailure,
    cleanSalesAcumulated as cleanSalesAcumulatedReducer,
    getStatusPublicationsRequest,
    getStatusPublicationsSuccess,
    getStatusPublicationsFailure,
    cleanStatusPublications as cleanStatusPublicationsReducer,
    getStatusTransactionsRequest,
    getStatusTransactionsSuccess,
    getStatusTransactionsFailure,
    cleanStatusTransactions as cleanStatusTransactionsReducer,
    getStatusChangesPublicationsRequest,
    getStatusChangesPublicationsSuccess,
    getStatusChangesPublicationsFailure,
    cleanStatusChangesPublications as cleanStatusChangesPublicationsReducer,
    getStatusChangesTransactionsRequest,
    getStatusChangesTransactionsSuccess,
    getStatusChangesTransactionsFailure,
    cleanStatusChangesPublications as cleanStatusChangesTransactionsReducer,
    getPublicationsSalesRequest,
    getPublicationsSalesSuccess,
    getPublicationsSalesFailure,
    cleanPublicationsSales as cleanPublicationsSalesReducer,
    getPublicationsReportSuccess,
    getPublicationsReportFailure,
    getPublicationsReportRequest
} from "../reducers/profile";
import { axiosClient } from "../config/axios";
import { catch401 } from "../helpers/actions";

export const setBranchDashboard = (value: string) => (dispatch: Dispatch) => _setBranchDashboard(value, dispatch);
const _setBranchDashboard = (value: string, dispatch: Dispatch) => dispatch({type: setBranchDashboardReducer, payload: value});

export const setDateDashboard = (start: string, end: string) => (dispatch: Dispatch) => _setDateDashboard(start, end, dispatch);
const _setDateDashboard = (start: string, end: string, dispatch: Dispatch) => dispatch({type: setDateDashboardReducer, payload: {start: start, end: end}});

export const getSalesPeriod = (date_start: string, date_end: string, type: string = "period") => (dispatch: Dispatch, getState: GetState) => _getSalesPeriod(date_start, date_end, type, dispatch, getState);
const _getSalesPeriod = async (date_start: string, date_end: string, type: string = "period", dispatch: Dispatch, getState: GetState) => {
    try {
        if(type === "period"){
            dispatch({ type: getSalesPeriodRequest });
        }else{
            dispatch({ type: getSalesAcumulatedRequest });
        }
        const profile: any = getState().auth.user?.profile?.code;
        const branch = getState().profile?.dashboard?.branch;
        const userBranch = getState().auth.user?.branch;
        const userDealership = getState().auth.user?.dealership;
        const userId = getState().auth.user?._id;
        
        // Validate required parameters for admin-brand users
        if(profile === "admin-brand" && !userBranch) {
            console.log("Cannot make sales-period request: branch is required for admin-brand users");
            return;
        }
        
        let role = `branch=${branch || userBranch}`;
        if(branch === "all"){
            role = `dealership=${userDealership}`;
        }
        if(profile === "seller"){
            role = `user=${userId}`;
        }

        const response = await axiosClient.get(`${api.reports}/sales-period?date_start=${date_start}&date_end=${date_end}&${role}`);

        if(type === "period"){
            dispatch({ type: getSalesPeriodSuccess, payload: response?.data.data?.sales_period});
        }else{
            dispatch({ type: getSalesAcumulatedSuccess, payload: response?.data.data?.sales_period});
        }

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);

        if(type === "period"){
            dispatch({ type: getSalesPeriodFailure , payload: errorResponse?.code});
        }else{
            dispatch({ type: getSalesAcumulatedFailure , payload: errorResponse?.code});
        }
    }
};

export const cleanSalesPeriod = () => (dispatch: Dispatch) => _cleanSalesPeriod(dispatch);
const _cleanSalesPeriod = (dispatch: Dispatch) => dispatch({type: cleanSalesPeriodReducer});

export const cleanSalesAcumulated = () => (dispatch: Dispatch) => _cleanSalesAcumulated(dispatch);
const _cleanSalesAcumulated = (dispatch: Dispatch) => dispatch({type: cleanSalesAcumulatedReducer});

export const getStatusPublications = (date_start: string, date_end: string) => (dispatch: Dispatch, getState: GetState) => _getStatusPublications(date_start, date_end, dispatch, getState);
const _getStatusPublications = async (date_start: string, date_end: string, dispatch: Dispatch, getState: GetState) => {
    try {
        dispatch({ type: getStatusPublicationsRequest });
        const profile: any = getState().auth.user?.profile?.code;
        const branch = getState().profile?.dashboard?.branch;
        const userBranch = getState().auth.user?.branch;
        const userDealership = getState().auth.user?.dealership;
        const userId = getState().auth.user?._id;
        
        // Validate required parameters for admin-brand users
        if(profile === "admin-brand" && !userBranch) {
            console.log("Cannot make statuses-publications request: branch is required for admin-brand users");
            return;
        }
        
        let role = `branch=${branch || userBranch}`;
        if(branch === "all"){
            role = `dealership=${userDealership}`;
        }
        if(profile === "seller"){
            role = `user=${userId}`;
        }

        const response = await axiosClient.get(`${api.reports}/statuses-publications/status?date_start=${date_start}&date_end=${date_end}&${role}`);

        dispatch({ type: getStatusPublicationsSuccess, payload: response?.data.data?.statuses});

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getStatusPublicationsFailure , payload: errorResponse?.code});
    }
};

export const cleanStatusPublications = () => (dispatch: Dispatch) => _cleanStatusPublications(dispatch);
const _cleanStatusPublications = (dispatch: Dispatch) => dispatch({type: cleanStatusPublicationsReducer});

export const getStatusTransactions = (date_start: string, date_end: string) => (dispatch: Dispatch, getState: GetState) => _getStatusTransactions(date_start, date_end, dispatch, getState);
const _getStatusTransactions = async (date_start: string, date_end: string, dispatch: Dispatch, getState: GetState) => {
    try {
        dispatch({ type: getStatusTransactionsRequest });
        const profile: any = getState().auth.user?.profile?.code;
        const branch = getState().profile?.dashboard?.branch;
        const userBranch = getState().auth.user?.branch;
        const userDealership = getState().auth.user?.dealership;
        const userId = getState().auth.user?._id;
        
        // Validate required parameters for admin-brand users
        if(profile === "admin-brand" && !userBranch) {
            console.log("Cannot make statuses-transactions request: branch is required for admin-brand users");
            return;
        }
        
        let role = `branch=${branch || userBranch}`;
        if(branch === "all"){
            role = `dealership=${userDealership}`;
        }
        if(profile === "seller"){
            role = `user=${userId}`;
        }

        const response = await axiosClient.get(`${api.reports}/statuses-transactions/status?date_start=${date_start}&date_end=${date_end}&${role}`);

        dispatch({ type: getStatusTransactionsSuccess, payload: response?.data.data?.statuses});

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getStatusTransactionsFailure , payload: errorResponse?.code});
    }
};

export const cleanStatusTransactions = () => (dispatch: Dispatch) => _cleanStatusTransactions(dispatch);
const _cleanStatusTransactions = (dispatch: Dispatch) => dispatch({type: cleanStatusTransactionsReducer});

export const getPublicationsSales = () => (dispatch: Dispatch, getState: GetState) => _getPublicationsSales(dispatch, getState);
const _getPublicationsSales = async (dispatch: Dispatch, getState: GetState) => {
    try {
        dispatch({ type: getPublicationsSalesRequest });
        const profile: any = getState().auth.user?.profile?.code;
        const branch = getState().profile?.dashboard?.branch;
        const userBranch = getState().auth.user?.branch;
        const userDealership = getState().auth.user?.dealership;
        const userId = getState().auth.user?._id;
        
        // Validate required parameters for admin-brand users
        if(profile === "admin-brand" && !userBranch) {
            console.log("Cannot make anual-publications-sales request: branch is required for admin-brand users");
            return;
        }
        
        let role = `branch=${branch || userBranch}`;
        if(branch === "all"){
            role = `dealership=${userDealership}`;
        }
        if(profile === "seller"){
            role = `user=${userId}`;
        }
        
        const response = await axiosClient.get(`${api.reports}/anual-publications-sales?${role}`);

        dispatch({ type: getPublicationsSalesSuccess, payload: response?.data.data});

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getPublicationsSalesFailure , payload: errorResponse?.code});
    }
};

export const cleanPublicationsSales = () => (dispatch: Dispatch) => _cleanPublicationsSales(dispatch);
const _cleanPublicationsSales = (dispatch: Dispatch) => dispatch({type: cleanPublicationsSalesReducer});

export const getStatusChangesPublications = (date_start: string, date_end: string) => (dispatch: Dispatch, getState: GetState) => _getStatusChangesPublications(date_start, date_end, dispatch, getState);
const _getStatusChangesPublications = async (date_start: string, date_end: string, dispatch: Dispatch, getState: GetState) => {
    try {
        dispatch({ type: getStatusChangesPublicationsRequest });
        const profile: any = getState().auth.user?.profile?.code;
        const branch = getState().profile?.dashboard?.branch;
        const userBranch = getState().auth.user?.branch;
        const userDealership = getState().auth.user?.dealership;
        const userId = getState().auth.user?._id;
        
        // Validate required parameters for admin-brand users
        if(profile === "admin-brand" && !userBranch) {
            console.log("Cannot make last-publications request: branch is required for admin-brand users");
            return;
        }
        
        let role = `branch=${branch || userBranch}`;
        if(branch === "all"){
            role = `dealership=${userDealership}`;
        }
        if(profile === "seller"){
            role = `user=${userId}`;
        }

        const response = await axiosClient.get(`${api.reports}/last-publications?limit=5&date_start=${date_start}&date_end=${date_end}&${role}`);

        dispatch({ type: getStatusChangesPublicationsSuccess, payload: response?.data.data?.last_publications});

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getStatusChangesPublicationsFailure , payload: errorResponse?.code});
    }
};

export const cleanStatusChangesPublications = () => (dispatch: Dispatch) => _cleanStatusChangesPublications(dispatch);
const _cleanStatusChangesPublications = (dispatch: Dispatch) => dispatch({type: cleanStatusChangesPublicationsReducer});

export const getStatusChangesTransactions = (date_start: string, date_end: string) => (dispatch: Dispatch, getState: GetState) => _getStatusChangesTransactions(date_start, date_end, dispatch, getState);
const _getStatusChangesTransactions = async (date_start: string, date_end: string, dispatch: Dispatch, getState: GetState) => {
    try {
        dispatch({ type: getStatusChangesTransactionsRequest });
        const token: string = getState().auth.token;
        const profile: any = getState().auth.user?.profile?.code;
        const branch = getState().profile?.dashboard?.branch;
        const userBranch = getState().auth.user?.branch;
        const userDealership = getState().auth.user?.dealership;
        const userId = getState().auth.user?._id;
        
        // Validate required parameters for admin-brand users
        if(profile === "admin-brand" && !userBranch) {
            console.log("Cannot make last-transactions request: branch is required for admin-brand users");
            return;
        }
        
        let role = `branch=${branch || userBranch}`;
        if(branch === "all"){
            role = `dealership=${userDealership}`;
        }
        if(profile === "seller"){
            role = `user=${userId}`;
        }

        const response = await axiosClient.get(`${api.reports}/last-transactions?limit=5&date_start=${date_start}&date_end=${date_end}&${role}`);

        dispatch({ type: getStatusChangesTransactionsSuccess, payload: response?.data.data?.last_transactions});

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getStatusChangesTransactionsFailure , payload: errorResponse?.code});
    }
};

export const cleanStatusChangesTransactions = () => (dispatch: Dispatch) => _cleanStatusChangesTransactions(dispatch);
const _cleanStatusChangesTransactions = (dispatch: Dispatch) => dispatch({type: cleanStatusChangesTransactionsReducer});


export const getPublicationsReport = (date_start: string, date_end: string, typeCar: string) => (dispatch: Dispatch, getState: GetState) => _getPublicationsReport(date_start, date_end, typeCar, dispatch, getState);
const _getPublicationsReport = async (date_start: string, date_end: string, typeCar: string, dispatch: Dispatch, getState: GetState) => {
    try {
        dispatch({ type: getPublicationsReportRequest });

        const response = await axiosClient.post(`${api.reports}/publications/reports?condition=${typeCar}`, {}, {
            responseType: 'blob'
        });

        // Create blob and download
        const blob = new Blob([response.data], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        
        // Format current date
        const now = new Date();
        const formattedDate = now.toISOString().split('T')[0]; // Format: YYYY-MM-DD
        
        link.setAttribute('download', `publications-report-${formattedDate}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        console.log("response",response)
        dispatch({ type: getPublicationsReportSuccess, payload: response});

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse?.code);
        catch401(errorResponse?.code,dispatch);
        dispatch({ type: getPublicationsReportFailure , payload: errorResponse?.code});
    }
};